import { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../../css/FilterAdminUsers.css";
import { useTranslation } from "react-i18next";

export default function FilterSteps({ customRoles, setFilters }) {
  const { t } = useTranslation();
  const [stepName, setStepName] = useState("");
  const [role, setRole] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isRoleOpen, setIsRoleOpen] = useState(false);

  const allRoles = [
    ...(customRoles?.map((r) => r.role_name) || []),
  ];

  const roleDropdownRef = useRef(null);

  // ✅ Update filters whenever inputs change
  useEffect(() => {
    setFilters({
      step_name: stepName || undefined,
      role: role || undefined,
    });
  }, [stepName, role]);

  // ✅ Validation for step name
  const handleStepNameChange = (e) => {
    const input = e.target.value;
    const valid = input.replace(/[^a-zA-Z0-9-_^\s]/g, "");
    setStepName(valid);
  };

  // ✅ Toggle visibility
  const handleToggleFilter = () => {
    if (isVisible) {
      setStepName("");
      setRole("");
    }
    setIsVisible((prev) => !prev);
  };

  // ✅ Handle outside click to close dropdown
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (roleDropdownRef.current && !roleDropdownRef.current.contains(e.target)) {
        setIsRoleOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="filter-wrapper">
      <button className="filter-toggle" onClick={handleToggleFilter}>
        <FontAwesomeIcon icon={isVisible ? faTimes : faMagnifyingGlass} />
      </button>

      {isVisible && (
        <div className="filter-container">
          {/* Step name filter */}
          <input
            type="text"
            className="filter-container-input-username"
            placeholder={t("filterSteps.stepNamePlaceholder", "Step name")}
            value={stepName}
            onChange={handleStepNameChange}
            pattern="[a-zA-Z0-9-_^\s]+"
            title={t("filterSteps.stepNameTitle", "Only letters, numbers, and spaces")}
          />

          {/* Role filter (dropdown) */}
          <div
            className="custom-dropdown"
            ref={roleDropdownRef}
            // onMouseLeave={() => setIsRoleOpen(false)}
          >
            <div
              className="filter-container-select"
              onClick={() => setIsRoleOpen(!isRoleOpen)}
            >
              {role || t("filterSteps.allRoles", "All roles")}
            </div>
            {isRoleOpen && (
              <div className="custom-dropdown-menu">
                <div
                  className="custom-dropdown-option"
                  onClick={() => {
                    setRole("");
                    setIsRoleOpen(false);
                  }}
                >
                  {t("filterSteps.allRoles", "All roles")}
                </div>

                {allRoles.map((r, idx) => (
                  <div
                    key={idx}
                    className="custom-dropdown-option"
                    onClick={() => {
                      setRole(r);
                      setIsRoleOpen(false);
                    }}
                  >
                    {r}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
